module.exports = __webpack_public_path__ + "img/veza-3NP.4776e232.png";